// React Imports
import * as React from "react";
import {useState, useEffect, createContext} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
// import {GridToolbarContainer, GridToolbarExport} from '@mui/x-data-grid';
import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid-pro";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import {InputLabel, Select, Stack, Tooltip} from "@mui/material";
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import {DataGridPro} from "@mui/x-data-grid-pro";
import Box from "@mui/material/Box";
import RefreshIcon from '@mui/icons-material/Refresh';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Typography from "@mui/material/Typography";
import DateRangeIcon from '@mui/icons-material/DateRange';

// App Imports
import {
    executeExpression
} from "../../ContractDataPoint/ContractDataPointClient";
import Button from "@mui/material/Button";
import {
    advanceApprovedByGuild,
    advanceContract,
    getMissingInput
} from "../../Contract/ContractClient";
import {changeWorkQueue} from "../workQueueSlice";
import WorkQueueDrawer from "../ContractDataPoints/WorkQueueDrawer";

import {
    applyDefault, getBulkEditListV2, getCdpvMegaPivot,
    updateRelatedExpressions
} from "../../ContractDataPointValue/ContractDataPointValueClient";
import {changeContractDataPoint} from "../../ContractDataPoint/contractDataPointSlice";
import {getAllDataPointAttributes, getPivotAttributes} from "../../DataPointAttribute/DataPointAttributeClient";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Drawer from "@mui/material/Drawer";
import ExpandIcon from "@mui/icons-material/Expand";


// main function
export default function CdpvMegaPivot(props) {


    const [attributes, setAttributes] = useState([]);

    // const selectorAttributeId = 263;
    const selectorAttributeDataPointId = useSelector((state) => state.workQueueSlc.value.selectedAttributeDataPointId);
    const selectorAttributeDataPointName = useSelector((state) => state.workQueueSlc.value.selectedAttributeDataPointName);
    const selectorAttributeId = useSelector((state) => state.workQueueSlc.value.selectedAttributeId);
    const selectorContractId = useSelector((state) => state.workQueueSlc.value.selectedContractId);
    const selectorVersionNumber = useSelector((state) => state.workQueueSlc.value.selectedVersionNumber);
    const [rowsIn, setRowsIn] = useState([]);
    const [pivotedRows, setPivotedRows] = useState([]);
    const [columns, setColumns] = useState([]);

    const [attributeId, setAttributeId] = useState( null);
    // const [attributeId, setAttributeId] = useState(
    //     Number(selectorPropertyDropdownTitleId) || 0
    // );
    const hideActions = localStorage.getItem('hideActions') === "true";

    const dispatchData = useDispatch();

    // useEffect(() => {
    //     console.log("CDP fetch triggered by cdp refresh = true");
    //     fetchcdpvMegaPivot();
    //     dispatchData(changeWorkQueue({cdpvMegaPivotState: true, cdpvMegaPivotRefresh: false}));
    // }, [useSelector((state) => state.workQueueSlc.value.cdpvMegaPivotRefresh)===true]);


    const cdpvMegaPivotRefresh = useSelector((state) => state.workQueueSlc.value.cdpvMegaPivotRefresh);


    const fetchAttributesForDropdowns = () =>
        // getAllDataPointAttributes()
        getPivotAttributes(selectorAttributeDataPointId)

            .then(data => {
                console.log("selectorAttributeDataPointId ", selectorAttributeDataPointId);
                console.log("Attributes List");
                console.log(data);
                setAttributes(data);
            })
    useEffect(() => {
        console.log("This is for the attributes dropdown...");
        console.log("selectorAttributeDataPointId ", selectorAttributeDataPointId);
        fetchAttributesForDropdowns();
    }, []);



    useEffect(() => {
        // if (!cdpvMegaPivotRefresh) return;
        fetchCdpvMegaPivot();
        dispatchData(changeWorkQueue({ cdpvMegaPivotState: true, cdpvMegaPivotRefresh: false }));
    }, [cdpvMegaPivotRefresh,selectorAttributeId, selectorContractId, selectorVersionNumber]);

    const handleRefreshGrid = () => {
        dispatchData(changeWorkQueue({cdpvMegaPivotRefresh: true}));
    };


    const handleBackButton = () => {
        dispatchData(changeWorkQueue({cdpvMegaPivotState: false}));
    };


    const handleAttributeChange = (selectedValue) => {
        dispatchData(changeWorkQueue({selectedAttributeId: selectedValue, cdpvMegaPivotRefresh: true}));
    };


    const handleAttributeClear = () => {
        setAttributeId(null);
        dispatchData(changeWorkQueue({cdpvMegaPivotRefresh: true}));
    };


    const handleClose = () => {
        setAttributeId(null);
        dispatchData(changeWorkQueue({cdpvMegaPivotState: false}));
    };


    const handleMegaDatePivot = () => {
        console.log("Show Mega Pivot");
        dispatchData(changeWorkQueue({cdpvMegaDatePivotState: true}));
    };

    const fetchCdpvMegaPivot = () => {
        if (selectorAttributeId != null && selectorContractId != null) {
            console.log("fetching cdpv pivot data.");
            console.log("attributeId = ", selectorAttributeId);
            console.log("contractId = ", selectorContractId);
            console.log("versionNumber = ", selectorVersionNumber);
            getCdpvMegaPivot(selectorAttributeId, selectorContractId, selectorVersionNumber)

                .then(data=>{setRowsIn(data);
                    console.log("Mega Pivot Data:");
                console.log(data);}
                )
                .catch(err => console.error("getCdpvMegaPivot failed", err))
                .finally(() => {console.log("getCdpvMegaPivot completed");
                    console.log("pivot data");
                    console.log(rowsIn)});
        }
    };


    // const fetchcdpvMegaPivot = () => {
    //     if (myAttributeId != null || myContractId != null
    //     ) {
    //         console.log("Fetching cdpv data for the following contract:");
    //         console.log(selectorContractId);
    //         getcdpvMegaPivot(selectorAttributeId, selectorContractId, selectorVersionNumber)

    //             .then(data => {
    //                 console.log("for Contract #", selectorContractId);
    //                 console.log("CDP data set retrieved");
    //                 console.log(data);
    //                 setRowsIn(data);
    //             })
    //     }
    // };

    // function buildColumns(pivotedRows) {
    //     const colNames = new Set();
    //     for (const row of pivotedRows) {
    //         Object.keys(row).forEach((k) => {
    //             if (k !== "iterationNumber") colNames.add(k);
    //         });
    //     }
    //
    //     return [
    //         { field: "iterationNumber", headerName: "Iteration", width: 120 },
    //         ...Array.from(colNames).sort().map((name) => ({
    //             field: name,
    //             headerName: name,
    //             flex: 1,
    //             minWidth: 160,
    //         })),
    //     ];
    // }




    function buildColumns(pivotedRows) {
        const fixedFields = new Set([
            "id",
            "rowNum",
            // "contractNumber",
            "cycleNumber",
            "dealName",
            "dealId",
            "contractName",
            "contractId",
        ]);

        const colNames = new Set();

        for (const row of pivotedRows) {
            Object.keys(row).forEach((k) => {
                if (!fixedFields.has(k)) {
                    colNames.add(k);
                }
            });
        }

        return [
            { field: "rowNum", headerName: "#", width: 60 },
            // { field: "contractNumber", headerName: "Contract", width: 100 },
            { field: "cycleNumber", headerName: "Cycle", width: 80 },
            { field: "dealName", headerName: "Deal Name", width: 250 },
            { field: "dealId", headerName: "Deal ID", width: 160 },
            { field: "contractName", headerName: "Contract Name", width: 300 },
            { field: "contractId", headerName: "Contract ID", width: 100 },

            ...Array.from(colNames).map((name) => ({
                field: name,
                headerName: name,
                width: 240,
                align: "right",
                headerAlign: "right",
                headerClassName: "wrap-header",
            })),
        ];
    }


    // function buildColumns(pivotedRows) {
    //     const colNames = new Set();
    //     for (const row of pivotedRows) {
    //         Object.keys(row).forEach((k) => {
    //             // if (k !== "id" && k !== "iterationNumber") colNames.add(k);
    //             if (k !== "id" && k !== "rowNum"
    //                 && k !== "contractNumber"
    //                 && k !== "dealId" && k !== "dealName"
    //                 && k !== "contractName" && k !== "contractId"
    //                 && k !== "cycleNumber"
    //             ) colNames.add(k);
    //         });
    //     }
    //
    //     return [
    //         { field: "rowNum", headerName: "#", width: 20
    //             // , hide: true
    //         },
    //         { field: "contractNumber", headerName: "Contract", width: 80
    //             // , hide: true
    //         },
    //         { field: "cycleNumber", headerName: "Cycle", width: 100
    //             // , hide: true
    //         },
    //         { field: "dealName", headerName: "Deal Name", width: 200
    //             // , hide: true
    //         },
    //         { field: "dealId", headerName: "Deal ID", width: 120
    //             // , hide: true
    //         },
    //         { field: "contractName", headerName: "Name", width: 200
    //             // , hide: true
    //         },
    //         // { field: "contractId", headerName: "Contract ID", width: 100
    //         //     // , hide: true
    //         // },
    //
    //
    //         // ...Array.from(colNames).sort().map((name) => ({
    //         ...Array.from(colNames).map((name) => ({
    //             field: name,
    //             headerName: name,
    //             width: 240,
    //             // flex: 1,
    //             // minWidth: 240,
    //             align: 'right',
    //             headerAlign: 'right',
    //
    //             headerClassName: "wrap-header",
    //         })),
    //     ];
    // }
    //     return [
    //         { field: "iterationNumber", headerName: "#", width: 20 },
    //         // ...Array.from(colNames).sort().map((name) => ({
    //         ...Array.from(colNames).map((name) => ({
    //             field: name,
    //             headerName: name,
    //             flex: 1,
    //             align: 'right',
    //             headerAlign: 'right',
    //             minWidth: 240,
    //             headerClassName: "wrap-header",
    //         })),
    //     ];
    // }


    function pivotForDisplay(rowsIn) {
        const byIter = new Map();

        for (const r of rowsIn) {
            if (!byIter.has(r.rowNum)) {
                byIter.set(r.rowNum, {
                    id: r.rowNum,               // REQUIRED
                    rowNum: r.rowNum,
                    // contractNumber: r.contractNumber,
                    cycleNumber: r.cycleNumber,
                    dealName: r.dealName,
                    dealId: r.dealId,
                    contractName: r.contractName,
                    contractId: r.contractId,
                });
            }
            byIter.get(r.rowNum)[r.dataPointName] = r.displayValue;
        }

        return Array.from(byIter.values()).sort(
            (a, b) => a.rowNum - b.rowNum
        );
    }

    // function pivotForDisplay(rowsIn) {
    //     const byIter = new Map();
    //
    //     for (const r of rowsIn) {
    //         if (!byIter.has(r.iterationNumber)) {
    //             byIter.set(r.iterationNumber, {
    //                 id: r.iterationNumber,               // REQUIRED
    //                 iterationNumber: r.iterationNumber,
    //             });
    //         }
    //         byIter.get(r.iterationNumber)[r.dataPointName] = r.displayValue;
    //     }
    //
    //     return Array.from(byIter.values()).sort(
    //         (a, b) => a.iterationNumber - b.iterationNumber
    //     );
    // }

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarExport excelOptions={{ fileName: "cdpv-pivot" }} />
            </GridToolbarContainer>
        );
    }

    // const pivoted = pivotForDisplay(apiRows);
    // const columns = buildColumns(pivoted);

    useEffect(() => {
        const pivoted = pivotForDisplay(rowsIn);
        setPivotedRows(pivoted);
        setColumns(buildColumns(pivoted));
    }, [rowsIn]);

    return (
        <div style={{ height: '100%' , width: '100%' }}>
            <Box style={{ height: 20}}/>
            <Stack direction="row" spacing={2} alignItems="center">
            <Typography
                onClick={() => handleClose()}
                style={{cursor: 'pointer'}}
                sx={{pl:2, fontSize: 24, fontWeight: 'Bold' }}
            >Pivot Across Peers</Typography>
            <Tooltip enterDelay={1000} title={"Include Other Periods"}>
                <IconButton onClick={() => handleMegaDatePivot()}
                    // sx={{pt: 0}}
                            sx={{
                                p: 0,                 // remove default padding
                                display: 'flex',
                                alignItems: 'center', // vertical center
                                justifyContent: 'center',
                                height: '100%',       // important if parent has height
                            }}
                >
                    <DateRangeIcon color="primary"  variant="standard"  />
                </IconButton>
            </Tooltip>
            </Stack>
            <br/>
            {/*<Stack direction="row" spacing={12}>*/}
            {/*    <Button onClick={() => handleBackButton()} >BACK</Button>*/}
            {/*</Stack>*/}
            {/*<Button onClick={() => handleRefreshGrid()} >REFRESH</Button>*/}
            <Stack direction="row" spacing={5} alignItems="center">
                <Box>
                    <Tooltip title={"contract id: " + selectorContractId}>
                        <Typography sx={{pl: 2, pt: 2, fontWeight: 'bold' }}
                                    style={{cursor: 'pointer'}}
                                    onClick={() => handleClose()}
                        >View By Attribute</Typography>
                    </Tooltip>
                </Box>


                {/*<InputLabel htmlFor="attributeId">Attribute</InputLabel>*/}
                {/*<Select*/}
                {/*    labelId="attributeId"*/}
                {/*    id="attributeId"*/}
                {/*    label="attributeId"*/}
                {/*    defaultValue=        {useSelector((state) => state.dataPointXrefSlc.value.attributeId)}*/}
                {/*    sx={{ width: 300 }}*/}
                {/* variant={"filled"}>*/}
                {/*    >*/}
                {/*    {attributes.map((AttributeItem) =>*/}
                {/*        <MenuItem value={AttributeItem.id}>{AttributeItem.name}</MenuItem>*/}
                {/*    )}*/}
                {/*</Select>*/}


                <FormControl variant="standard" sx={{  minWidth: 600 }}>
                    <InputLabel htmlFor="xyz"  onClick={handleAttributeClear}>Attributes for {selectorAttributeDataPointName}</InputLabel>
                    <Select
                        isClearable={true}
                        id="my_attribute_id"
                        // onChange={(newAttributeId) => {
                        //     setAttributeId(newAttributeId.target.value);
                        //     // console.log(newAttributeId.target.value);
                        //     handleAttributeChange(newAttributeId.target.value);
                        //     // handleProductTopLevelChange(newProductTopLevelValue.target);
                        // }}
                        onChange={(event) => {
                            const selectedValue = event.target.value;
                            setAttributeId(selectedValue);
                            handleAttributeChange(selectedValue);
                            // selectedAttributeId(selectedValue)
                        }}
                        // type= "submit"
                        defaultValue=  {selectorAttributeId}
                        value = {selectorAttributeId}
                    >
                        {attributes.map((AttributeItem) =>
                            <MenuItem value={AttributeItem.id}>{AttributeItem.name}</MenuItem>
                        )}
                    </Select>
                </FormControl>

            </Stack>
            <br/>

            <br/>
            <DataGridPro
                showToolbar
                columnHeaderHeight={80}
                sx={{
                    "& .cycle-even": {
                        backgroundColor: "#fafafa",
                    },
                    "& .cycle-odd": {
                        backgroundColor: "#e8f0fe",
                    },
                    "& .highlight-contract": {
                        fontWeight: "bold",
                    },
                    "& .wrap-header .MuiDataGrid-columnHeaderTitle": {
                        whiteSpace: "normal",
                        lineHeight: 1.2,
                        overflow: "visible",
                        textOverflow: "clip",
                    },
                }}
                style={{ height: '800px' , width: '1700px' }}
                aria-label={"cdpvMegaPivot"}
                rows={pivotedRows}
                rowThreshold={0}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={columns}
                density={"compact"}
                initialState={{
                    sorting: {
                        sortModel: [{ field: 'iterationNumber', sort: 'asc' }],
                    },
                }}
                components={{
                    Toolbar: CustomToolbar,
                }}

                // slots={{ toolbar: CustomToolbar }}
                // getRowClassName={(params) => {
                //     const cycle = params.row.cycleNumber ?? 0;
                //     return cycle % 2 === 0 ? "cycle-even" : "cycle-odd";
                // }}
                getRowClassName={(params) => {
                    const cycle = params.row.cycleNumber ?? 0;

                    const cycleClass =
                        cycle % 2 === 0 ? "cycle-even" : "cycle-odd";

                    const contractClass =
                        params.row.contractId === selectorContractId
                            ? "highlight-contract"
                            : "";

                    return `${cycleClass} ${contractClass}`;
                }}
            />

        </div>
    );



}




